import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { SliderSection } from '../components/SliderSection';
import { api } from '../services/api';

export const RegisterPage: React.FC = () => {
  const [name, setName] = useState('');
  const [matric, setMatric] = useState('');
  const [email, setEmail] = useState('');
  const [level, setLevel] = useState('100');
  const [password, setPassword] = useState('');
  const [verifyPassword, setVerifyPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== verifyPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const res = await api.registerVoter({ name, matric, email, level, password });
      if (res.success) {
        alert('Registration complete! Please log in with your credentials.');
        navigate('/');
      } else {
        setError(res.message || 'Error creating registration.');
      }
    } catch (err: any) {
      setError(err.message || 'Registration failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ backgroundColor: '#FFFFFF' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
          minHeight: '100vh',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', paddingBottom: '40px' }}>
          <Header />

          <div style={{ maxWidth: '480px', margin: '40px auto', padding: '0 32px', width: '100%' }}>
            <div style={{ marginBottom: '28px' }}>
              <span style={{ fontSize: '12px', fontWeight: 700, color: '#FF9900', textTransform: 'uppercase', letterSpacing: '1px' }}>
                Accreditation
              </span>
              <h1 style={{ fontSize: '30px', fontWeight: 800, color: '#171619', marginTop: '6px', marginBottom: '8px' }}>
                Register Your Details
              </h1>
              <p style={{ color: '#6B7280', fontSize: '14px' }}>
                Enter your student credentials below to initialize your voter accreditation.
              </p>
            </div>

            <form onSubmit={handleRegister}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div className="input-group">
                  <label>Full Name</label>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="Jane Doe"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="input-group">
                  <label>Matric Number</label>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="210001"
                    value={matric}
                    onChange={(e) => setMatric(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                <div className="input-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    className="input-field"
                    placeholder="student@ui.edu.ng"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="input-group">
                  <label>Level</label>
                  <select
                    className="input-field"
                    value={level}
                    onChange={(e) => setLevel(e.target.value)}
                    style={{ height: '48px', cursor: 'pointer' }}
                  >
                    <option value="100">100 Level</option>
                    <option value="200">200 Level</option>
                    <option value="300">300 Level</option>
                    <option value="400">400 Level</option>
                    <option value="500">500 Level</option>
                  </select>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div className="input-group">
                  <label>Password</label>
                  <input
                    type="password"
                    className="input-field"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="input-group">
                  <label>Verify Password</label>
                  <input
                    type="password"
                    className="input-field"
                    placeholder="Confirm"
                    value={verifyPassword}
                    onChange={(e) => setVerifyPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              {error && (
                <div style={{ color: '#EF4444', fontSize: '13px', fontWeight: 600, marginBottom: '16px' }}>
                  *{error}
                </div>
              )}

              <button type="submit" className="btn-primary" disabled={loading}>
                {loading ? 'Registering...' : 'Register & Return To Login'}
              </button>
            </form>

            <div style={{ marginTop: '24px', fontSize: '14px', color: '#6B7280' }}>
              Already registered?{' '}
              <Link to="/" style={{ color: '#FF9900', fontWeight: 600 }}>
                Log in here
              </Link>
            </div>
          </div>

          <div style={{ padding: '0 48px', color: '#9CA3AF', fontSize: '12px' }}>
            © {new Date().getFullYear()} Electpoll e-voting system
          </div>
        </div>

        <div>
          <SliderSection />
        </div>
      </div>
    </div>
  );
};
